var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.238,
    height: 16.145,
    viewBox: "0 0 19.238 16.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Jul-27-16-09-37",
    transform: "translate(-12.812 320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_880",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 880",
    d: "M39.908-319.91a.388.388,0,0,0-.1.359c.011.045,3.526,3.6,7.814,7.887,7.1,7.1,7.82,7.809,7.983,7.809.263,0,.392-.163.359-.448-.011-.045-.807-.88-1.777-1.85s-1.76-1.783-1.76-1.805a3.427,3.427,0,0,1,.527-.32,17.335,17.335,0,0,0,3.862-2.809c.538-.527.712-.734.712-.841s-.168-.308-.69-.813a15.116,15.116,0,0,0-7.131-4.019,7.208,7.208,0,0,0-1.822-.129,7.776,7.776,0,0,0-3.078.476l-.65.219L42.257-318.1c-1.7-1.7-1.923-1.9-2.085-1.9A.413.413,0,0,0,39.908-319.91Zm9.636,3.946a13.414,13.414,0,0,1,4.939,2.293,18,18,0,0,1,1.867,1.542l.247.252-.353.325a18.7,18.7,0,0,1-3.722,2.629l-.718.376-.863-.863-.863-.863.2-.37a2.361,2.361,0,0,0,.263-1.508,2.5,2.5,0,0,0-1.912-2.018,2.569,2.569,0,0,0-1.827.348l-.151.118-.891-.891c-.488-.488-.891-.908-.891-.931a8.017,8.017,0,0,1,2.074-.549A10.82,10.82,0,0,1,49.545-315.964Z",
    transform: "translate(-25.482)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_881",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 881",
    d: "M16.8-240.62a18,18,0,0,0-3.358,2.551c-.841.8-.841.79-.017,1.592a15.289,15.289,0,0,0,7.159,4.042,6.907,6.907,0,0,0,1.822.135,7.385,7.385,0,0,0,2.736-.376l.364-.112-4.059-4.059c-2.231-2.231-4.081-4.059-4.115-4.053A4.378,4.378,0,0,0,16.8-240.62Z",
    transform: "translate(0 -74.666)",
    fill: "#939a9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.97937b34a0a1765c8fd9f535206e47b7.svg";
export { ForwardRef as ReactComponent };